import $ from 'jquery'
import html from '../bootstrap/html'

let $document = $(document)

/**
 * Product gallery.
 */

// Replace control nav with custom thumb control
$document.on('wc-product-gallery-before-init', function(event, el, params) {
    let $gallery    = $(el)
    let $images     = $gallery.find('.woocommerce-product-gallery__image')
    let thumbs      = []
    let $thumbs

    // Enable show/hide animation
    params.photoswipe_options.showAnimationDuration = 333
    params.photoswipe_options.hideAnimationDuration = 333
    params.photoswipe_options.getThumbBoundsFn = function(index) {
        // find thumbnail element
        let thumbnail   = $images.get(index)    
        // get window scroll Y
        let pageYScroll = window.pageYOffset || document.documentElement.scrollTop; 
        // optionally get horizontal scroll
        // get position of element relative to viewport
        let rectEl      = $(thumbnail).closest('.flex-viewport').get(0) || thumbnail
        let rect        = rectEl.getBoundingClientRect() 
    
        // WooCommerce doesn't provice any hook to add msrc, so we use CSS.
        // https://github.com/woocommerce/woocommerce/blob/f3ceba5a95e700ef9429615b0ba82752ee328bb2/assets/js/frontend/single-product.js#L261-L288
        $document.find('#reka-pswp__img--placeholder-css').remove()
        $document.find('head').append(`<style id="reka-pswp__img--placeholder-css">
            .pswp__img--placeholder { 
                background-image: url(${$(thumbnail).find('img').attr('src')});
                background-size: cover;
                background-position: center; 
            }
        </style>`)

        // w = width
        return { 
            x: rect.left, 
            y: rect.top + pageYScroll, 
            w: rect.width
        }
    }

    function getThumbItemWidth() {
        return ($gallery.width() - 12) / 2
    }

    // Wait for header transition
    setTimeout(() => 
        $gallery.imagesLoaded(() => $gallery.addClass('media-ready')
    ), 1000)

    if ($images.length < 2) {
        return
    }

    // Collect thumb URLs
    $images.each((i, el) => thumbs.push($(el).data('thumb')))
    // Create thumb control
    $thumbs = $(html`
        <div class="flex-control-thumbs position-relative">
            <ul class="slides list-unstyled">
                ${thumbs.map(thumb => html`
                    <li><img src="${thumb}" /></li>
                `)}
            </ul>
        </div>
    `)

    // Disable control nav
    params.flexslider.controlNav        = false
    // Sync with thumb control
    params.flexslider.sync              = $thumbs
    params.flexslider.animationSpeed    = 1000

    $gallery.one('wc-product-gallery-after-init', function() {        
        $gallery.append($thumbs)
        $thumbs.flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            animationSpeed: 1000,
            slideshow: false,
            asNavFor: $gallery,
            prevText: '',
            nextText: '',
            itemMargin: 12,
            itemWidth: getThumbItemWidth()
        })
    
        // Update thumb width on resize
        $(window).resize(function() {
            $thumbs.data('flexslider').vars.itemWidth = getThumbItemWidth()
        })
    })
})

/**
 * Quantity fields.
 */

+function() {
    function minus($qty) {
        let val = parseInt($qty.val())
    
        $qty.val(val > 1 ? val - 1 : 1)
        $qty.trigger('input')
    }

    function plus($qty) {
        let val = parseInt($qty.val())
    
        $qty.val(val + 1)
        $qty.trigger('input')
    }

    // Plus and minus button.
    $document.on('click', '.quantity .minus, .quantity .plus', function() {
        let $this   = $(this)
        let $qty    = $(this).siblings('.qty')

        if ($this.hasClass('minus')) {
            minus($qty)
        } else {
            plus($qty)
        }
    })

    // Up and down keys.
    $document.on('keydown', '.input-text.qty', function(event) {
        let $qty = $(this)

        switch(event.which) {   
            // up 
            case 38:
                plus($qty) 
                break;
    
            // down
            case 40: 
                minus($qty)
                break;
        }
    })
}()

/**
 * Cart form
 */

// AJAX add to cart
$document.on('submit', '.single-product form.cart', function(event) {
    let $form = $(this)

    if (!$form.closest('.product').hasClass('product-type-simple')) {
        return
    }

    let data        = $form.serializeArray()
    let $button     = $form.find('.single_add_to_cart_button')

    data.push({
        name: 'product_id',
        value: $button.val()
    })
    
    $form.block()

    $.ajax({
        method: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
        data: data,
        dataType: 'json',
        success: function( response ) {
            if (!$document.find('#push-cart').hasClass('active')) {
                $document.find('.push-toggle[href="#push-cart"]').trigger('click')
            }

            $.each( response.fragments, function( key ) {
				$( key )
					.addClass( 'updating' )
					.fadeTo( '400', '0.6' )
			});

			$.each( response.fragments, function( key, value ) {
				$( key ).replaceWith( value );
				$( key ).stop( true ).css( 'opacity', '1' )
			});
        },
        complete: function() {
            $form.unblock()
        }
    })

    event.preventDefault()
})